export default {"src":"/_next/static/media/cube.52e85b6f.svg","height":21,"width":18};